module.exports = __webpack_public_path__ + "img/imgMonths.3d69d0d8.webp";